'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import Raven from 'raven-js';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import Chapter from 'academy-shared-js/records/Chapter';
import Quiz from 'academy-shared-js/records/Quiz';
import Video from 'academy-shared-js/records/Video';
import PracticalExercise from 'academy-shared-js/records/PracticalExercise';
import Link from 'academy-shared-js/records/Link';
import ContentItem from '../../../components/Navigator/LessonNavigator/ContentItem';
import { getHumanizedDuration } from '../../../utils/utils';
import { getContentNameByType } from '../../../utils/ContentUtils';
import { canOperateOnLesson, lessonHasError } from '../../../selectors/lessonSelectors';
import { PracticalExerciseTypes } from '../../../constants/ContentConstants';

function mapStateToProps(state, ownProps) {
  const {
    id,
    parentId,
    urlPrefix
  } = ownProps;
  const content = state.contentById.get(id);
  const linkType = content && content.get('linkType');
  let heading = getContentNameByType(content);
  let subheading;

  if (content instanceof Quiz) {
    subheading = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.navigator.questionNumber",
      options: {
        count: content.get('questions').size
      }
    });
  } else if (content instanceof Video) {
    subheading = getHumanizedDuration(content.get('duration'));
  } else if (content instanceof PracticalExercise) {
    if (content.get('type') === PracticalExerciseTypes.MANUALLY_GRADED_WITH_FILE_SUBMISSION) {
      heading = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.manualPETitle",
        options: {
          title: content.get('name')
        }
      });
      subheading = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.uploadFileOrLink"
      });
    } else {
      subheading = content.get('name');
    }
  } else if (content instanceof Link) {
    subheading = /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.resources.type.${linkType}`
    });
  } else if (content instanceof Chapter) {
    subheading = /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'learningCenter.lessonNavigator.chapters.durationSubheading',
      options: {
        minutes: getHumanizedDuration(content.get('readingTimeMinutes') * 60)
      }
    });
  } else {
    // content not ready; check for error or genuine unsupported content
    const lessonId = {
      match: {
        params: {
          lessonId: parentId
        }
      }
    };
    const hasLessonError = lessonHasError(state, lessonId);
    const isLessonReady = canOperateOnLesson(state, lessonId);

    if (hasLessonError || isLessonReady && !!content) {
      Raven.captureMessage(`ContentItemContainer: Unsupported content type, id of ${content && content.get('id')}`);
    }

    heading = /*#__PURE__*/_jsx(SkeletonText, {});
    subheading = /*#__PURE__*/_jsx(SkeletonText, {});
  }

  return {
    url: `/${urlPrefix}/${parentId}/${id}`,
    heading,
    subheading
  };
}

export default connect(mapStateToProps)(ContentItem);